<template>
  <div>
    <v-expand-transition>
      <div v-if="registered">
        <div class="text-center black--text">
          <v-icon color="primary" x-large>fa-check-circle</v-icon>
          <p class="mt-4">{{$t('demoRegistrationSuccessful')}}</p>
          <p class>{{$t('contactYou')}}</p>
        </div>
      </div>
      <v-form
        id="sign_up_form"
        v-else
        class="text-center"
        @submit.prevent="requestDemo"
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <div class="title primary--text mb-2">{{$t('requestTrialFourteenDays')}}</div>
        <div class="wrapper_signup">
          <v-text-field
            dense
            outlined
            color="primary"
            name="firstname"
            class="wrapper_signup_firstname"
            v-model="customer.firstname"
            :rules="requiredRules($t('firstname'))"
            v-bind:label="$t('firstname')"
            required
          ></v-text-field>
          <!-- <v-spacer class="ma-1"></v-spacer> -->
          <v-text-field
            dense
            outlined
            color="primary"
            name="lastname"
            class="wrapper_signup_lastname"
            v-model="customer.lastname"
            :rules="requiredRules($t('name'))"
            v-bind:label="$t('name')"
            required
          ></v-text-field>
          <!-- </div> -->
          <v-text-field
            dense
            outlined
            color="primary"
            name="company"
            class="wrapper_signup_customer"
            v-model="customer.name"
            :rules="requiredRules($t('company'))"
            v-bind:label="$t('company')"
            required
          ></v-text-field>
          <!-- <div :class="$vuetify.breakpoint.xs ?'': 'd-flex'"> -->
          <v-text-field
            dense
            outlined
            color="primary"
            name="street"
            class="wrapper_signup_street"
            v-model="customer.street"
            :rules="requiredRules($t('street'))"
            v-bind:label="$t('street')"
            required
          ></v-text-field>
          <!-- <v-spacer class="ma-1"></v-spacer> -->
          <v-text-field
            dense
            outlined
            color="primary"
            name="streetNr"
            class="wrapper_signup_streetNr"
            v-model="customer.streetNr"
            :rules="requiredRules($t('number'))"
            v-bind:label="$t('number')"
            required
          ></v-text-field>
          <!-- </div> -->
          <!-- <div :class="$vuetify.breakpoint.xs ?'': 'd-flex'"> -->
          <v-text-field
            dense
            outlined
            color="primary"
            name="postalCode"
            class="wrapper_signup_postalCode"
            v-model="customer.postalCode"
            :rules="requiredRules($t('postalcode'))"
            v-bind:label="$t('postalcode')"
            required
          ></v-text-field>
          <!-- <v-spacer class="ma-1"></v-spacer> -->
          <v-text-field
            dense
            outlined
            color="primary"
            name="city"
            class="wrapper_signup_city"
            v-model="customer.city"
            :rules="requiredRules($t('city'))"
            v-bind:label="$t('city')"
            required
          ></v-text-field>
          <!-- </div> -->
          <!-- <div :class="$vuetify.breakpoint.xs ?'': 'd-flex'"> -->
          <v-select
            v-model="selectedCountry"
            dense
            outlined
            :rules="requiredRules($t('country'))"
            v-bind:label="$t('country')"
            color="primary"
            class="wrapper_signup_country"
            :items="countries"
            item-value="code"
            item-text="name"
          ></v-select>
          <input type="hidden" name="country" :value="selectedCountry">
          <!-- <v-text-field
            dense
            outlined
            color="primary"
            class="wrapper_signup_country"
            v-model="customer.country"
            :rules="requiredRules($t('country'))"
            v-bind:label="$t('country')"
            required
          ></v-text-field>-->
          <!-- </div> -->
          <!-- <div :class="$vuetify.breakpoint.xs ?'': 'd-flex'"> -->
          <template
            v-if="selectedCountry && companies.filter(x => x.code == selectedCountry).length > 0"
          >
            <div class="wrapper_signup_company pa-1">
              <div class="black--text">{{$t('chooseYourPartner')}}</div>
              <div v-if="selectedCountry && selectedCountry == 'DE'" class="black--text font-weight-light">Since 01/01/2021, Kiesewetter and Seidemann are called Isopartner Germany</div>
              <v-radio-group
                class="mb-0 mt-0"
                name="partner"
                :rules="requiredRules($t('partner'))"
                v-model="selectedCompany"
                row
              >
                <v-radio
                  class="mb-0"
                  :label="company.name"
                  :value="company.name"
                  v-for="(company,i) in companies.filter(x => x.code == selectedCountry)"
                  :key="i"
                ></v-radio>
                <v-radio class="mb-0" :label="$t('noPartner')" :value="noPartner.name"></v-radio>
              </v-radio-group>
            </div>
          </template>
          <v-text-field
            dense
            outlined
            color="primary"
            name="email"
            class="wrapper_signup_email"
            v-model="customer.email"
            :rules="emailRules()"
            v-bind:label="$t('email')"
            required
          ></v-text-field>
          <!-- <v-spacer class="ma-1"></v-spacer> -->
          <v-text-field
            dense
            outlined
            color="primary"
            name="phone"
            class="wrapper_signup_phone"
            v-model="customer.phone"
            :rules="requiredRules($t('mobile'))"
            v-bind:label="$t('mobile')"
            required
          ></v-text-field>
        </div>
        <!-- <v-text-field
        dense
        outlined
        color="primary"
        class
        v-model="customer.vatNumber"
        :rules="requiredRules($t('vat'))"
        v-bind:label="$t('vat')"
        required
        ></v-text-field>-->
        <v-textarea
          dense
          outlined
          color="primary"
          name="comments"
          class="wrapper_comments"
          v-model="customer.comments"
          v-bind:label="$t('comments')"
        ></v-textarea>
        <v-text-field
          dense
          outlined
          color="primary"
          class="d-none"
          id="website"
          v-model="customer.honeypot"
          required
        ></v-text-field>
        <v-btn block x-large type="submit" color="primary" :loading="loading">{{$t('requestTrial')}}</v-btn>
      </v-form>
    </v-expand-transition>
  </div>
</template>

<script>
import { serviceihub } from "@/services/service.ihub.js";
const _serviceIhub = new serviceihub();
export default {
  computed: {
    countries() {
      let countries = [
        { code: "BE", name: this.$t("belgium") },
        { code: "EN", name: this.$t("unitedKingdom") },
        { code: "DE", name: this.$t("germany") },
        { code: "AU", name: this.$t("austria") },
        { code: "RO", name: this.$t("romania") },
        { code: "SE", name: this.$t("sweden") },
        { code: "HU", name: this.$t("hungary") },
        { code: "NL", name: this.$t("netherlands") },
        { code: "NN", name: this.$t("norway") },
        { code: "SW", name: this.$t("switzerland") },
        { code: "SP", name: this.$t("spain") }
      ];
      return countries.sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      );
    }
  },
  data: () => {
    return {
      registered: false,
      loading: false,
      valid: false,
      selectedCountry: null,
      selectedCompany: null,
      noPartner: {
        id: 0,
        name: "No partner"
      },
      companies: [
        { id: 2, code: "BE", name: "Isowill" },
        { id: 1, code: "BE", name: "Waeyeart Vermeersch" },
        { id: 12, code: "BE", name: "Caremiso" },
        { id: 3, code: "NL", name: "Jacosol" },
        // { id: 6, code: "DE", name: "Kiesewetter" },
        // { id: 6, code: "DE", name: "Seidemann" },
        { id: 7, code: "SE", name: "Profisol" },
        { id: 8, code: "SW", name: "Regisol" },
        { id: 4, code: "AU", name: "Isolier- und Dämmtechnik" },
        { id: 7, code: "DE", name: "Isopartner" },
        { id: 9, code: "EN", name: "TIDL" },
        { id: 10, code: "HU", name: "Isolier- und Dämmtechnik" },
        { id: 13, code: "RO", name: "Isolier- und Dämmtechnik" },
        { id: 14, code: "SP", name: "Grupo Flexicel" }
      ],
      customer: {
        name: "",
        firstname: "",
        lastname: "",
        street: "",
        streetNr: "",
        postalCode: "",
        city: "",
        country: "",
        VATNumber: "",
        email: "",
        phone: "",
        honeypot: "",
        company: null,
        isCustomer: false
      }
    };
  },
  mounted() {
      let form = document.getElementById("sign_up_form");
     var newScript = document.createElement("script");
    var inlineScript = document
    .createTextNode("var __ss_noform = __ss_noform || [];\
    __ss_noform.push(['baseURI', 'https://app-3QNF04NCZU.marketingautomation.services/webforms/receivePostback/MzawMDGzMDO3BAA/']);\
    __ss_noform.push(['form','sign_up_form', 'da97a78a-bb79-44c6-b6a3-643228b4caaa']);\
    __ss_noform.push(['submitType', 'manual']);");
    newScript.appendChild(inlineScript);
    form.parentNode.insertBefore(newScript, form.nextSibling);

    let sharpspringElement = document.createElement("script");
    sharpspringElement.setAttribute(
      "src",
      "https://koi-3QNF04NCZU.marketingautomation.services/client/noform.js?ver=1.24"
    );
    newScript.parentNode.insertBefore(sharpspringElement, newScript.nextSibling);
  },
  methods: {
    changeLanguage(language) {
      this.$i18n.locale = language;
      localStorage.setItem("language", language);
    },
    fromCodePoint(codepoint) {
      if (codepoint.split(" ").length > 0) {
        return (
          String.fromCodePoint(codepoint.split(" ")[0]) +
          String.fromCodePoint(codepoint.split(" ")[1])
        );
      }
      return String.fromCodePoint(codepoint);
    },
    requestDemo() {
      if (this.valid && this.$refs.form.validate()) {
        if (this.customer.honeypot.length == 0) {          
          this.loading = true;
          this.customer.country = this.selectedCountry;
          this.customer.company = this.selectedCompany;
          if (localStorage.getItem("language") == null) {
            localStorage.setItem("language", "EN");
          }
          window.__ss_noform.push([
            "submit",
            null,
            "da97a78a-bb79-44c6-b6a3-643228b4caaa"
          ]);
          _serviceIhub
            .requestDemo(this.customer)
            .then(res => {
              this.loading = false;
              this.registered = true;
            })
            .catch(err => {
              this.$noty.error(this.$t("error"));
              console.log(err);
              this.loading = false;
            });
        }
      }
    },
    emailRules() {
      return [
        v => !!v || `${this.$t("email")} ${this.$t("required")}`,
        v => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(v) || `${this.$t("email")} ${this.$t("invalid")}`;
        }
      ];
    },
    requiredRules(property) {
      return [v => !!v || `${property} ${this.$t("required")}`];
    }
  }
};
</script>

<style scoped>
.wrapper_signup {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-areas:
    "firstname firstname lastname lastname"
    "customer customer customer customer"
    "street street street streetNr"
    "postalCode postalCode city city"
    "country country country country"
    "company company company company"
    "email email email email"
    "phone phone phone phone";
  /* grid-gap: .2rem; */
  grid-column-gap: 0.2rem;
}
.wrapper_signup_firstname {
  grid-area: firstname;
}
.wrapper_signup_lastname {
  grid-area: lastname;
}
.wrapper_signup_customer {
  grid-area: customer;
}
.wrapper_signup_street {
  grid-area: street;
}
.wrapper_signup_streetNr {
  grid-area: streetNr;
}
.wrapper_signup_postalCode {
  grid-area: postalCode;
}
.wrapper_signup_city {
  grid-area: city;
}
.wrapper_signup_country {
  grid-area: country;
}
.wrapper_signup_email {
  grid-area: email;
}
.wrapper_signup_phone {
  grid-area: phone;
}
.wrapper_signup_company {
  grid-area: company;
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/Authentication/Signup.vue